import { StrictMode, Suspense, useEffect } from 'react';
import { QueryClientProvider } from 'react-query';

import { HotsauceProvider } from '@hotjar/hotsauce';
import { measureAndLog } from '@hotjar/performance';
import { useTranslation } from '@hotjar/translations';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import { onNavigate } from '@hotjar/webapp/utils/routing/on-navigate';
import { BrowserRouter } from '@hotjar/webapp-routing';
import { DataPrefetcher } from '@hotjar/webapp/components/DataPrefetcher';
import { MARKS } from '@hotjar/webapp/performance';

export const AppProviders = ({ children }: { children: JSX.Element }): JSX.Element => {
  useEffect(() => {
    // Perf: Mark application providers render timings
    measureAndLog({
      name: MARKS.APP_PROVIDERS_RENDERED,
      startMark: MARKS.APP_INITIALIZED,
      addMark: true,
    });
  }, []);

  const { i18n, ready } = useTranslation();

  return (
    <StrictMode>
      <HotsauceProvider
        i18n={{
          strings: ready ? i18n.getResourceBundle(i18n.language, 'hotsauce') : {},
        }}
        onNavigate={onNavigate}
      >
        <QueryClientProvider client={queryClient}>
          {/* We use a custom history object here so that we can access it from the Angular app to allow
         navigation between the react and angular apps. */}
          <BrowserRouter>
            <DataPrefetcher>
              <Suspense fallback={null}>{children}</Suspense>
            </DataPrefetcher>
          </BrowserRouter>
        </QueryClientProvider>
      </HotsauceProvider>
    </StrictMode>
  );
};
